import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import Img from 'gatsby-image';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default () => {
  const data = useStaticQuery(graphql`
    query {
      Banner: file(relativePath: { eq: "PolicyResearchAdvocacyHero.jpg" }) {
        childImageSharp {
          # Specify a fluid image and fragment
          # The default maxWidth is 800 pixels
          fluid(maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  return (
    <div className="antialiased text-gray-900 min-h-screen flex flex-col">
      <Navbar />
      <div style={{ height: '19rem' }}>
        <Img
          fluid={data.Banner.childImageSharp.fluid}
          className="h-full w-full object-cover"
          imgStyle={{ objectPosition: '50% 57%' }}
        />
      </div>
      <main className="flex-grow">
        <div className="max-w-screen-md mx-auto mb-12 px-12">
          <h1 className="text-center font-bold text-4xl mt-4">
            Policy Research & Advocacy
          </h1>
          <div className="mt-8">
            <div className="mt-2">
              Good policies have been critical for the development of renewable
              energy, increasing energy efficiency, and accelerating the pace of
              the energy transition. Strong policies at the local, state, and
              federal level have enabled renewable energy costs to decline
              dramatically in recent years, supporting the exponential growth of
              wind and solar throughout the world. Smart policies have enabled
              ongoing advances in energy efficiency, greatly reducing energy
              costs through improvements to appliances like refrigerators and
              lighting.
            </div>
            <div className="mt-2">
              Apogee works for strong clean energy policies at the local and
              state level in Kentucky. We provide policy research and technical
              assistance on topics such as net metering, distributed generation,
              electric utility rates and policies, and other topics related to
              energy and the environment.
            </div>
            <div className="mt-2 mb-16">
              To learn more about our policy work, please{' '}
              <Link to="/contact/">contact us</Link>.
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
